export const SNIPPETS_ONBOARDING = {
	HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL: 'snippets:hasSeenFirstSnippetCreatedModal',
} as const;

export const SnippetsOnboardingKeys = [...Object.values(SNIPPETS_ONBOARDING)] as const;
